import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import { MoreVertical } from 'lucide-mui';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../../globalModals/globalModalsSlice';
import { ActionType, FolderType } from '../../../../types';

type FolderMenuProps = {
  folder: FolderType;
};

type FolderMenuKeys = 'rename' | 'delete';
type FolderMenuType = ActionType<FolderMenuKeys>;

const actions: FolderMenuType[] = [
  {
    key: 'rename',
    label: 'Rename',
    'data-testid': 'rename-folder-option',
  },
  {
    key: 'delete',
    label: 'Delete',
    'data-testid': 'delete-folder-option',
  },
];

const FolderMenu: React.FC<FolderMenuProps> = ({ folder }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMoreIconClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (key: FolderMenuKeys) => {
    switch (key) {
      case 'rename':
        dispatch(pushModal({ type: 'rename-folder-modal', files: [folder] }));
        handleClose();
        break;
      case 'delete':
        dispatch(pushModal({ type: 'delete-folder-modal', files: [folder] }));
        handleClose();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Tooltip title="Options" arrow>
        <IconButton
          aria-label="more"
          aria-controls="folder-menu"
          aria-haspopup="true"
          onClick={handleMoreIconClick}
          data-testid="folder-more-option"
        >
          <MoreVertical />
        </IconButton>
      </Tooltip>
      <Menu
        id="folder-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map(({ key, label }) => (
          <MenuItem key={key} onClick={() => handleActionClick(key)}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FolderMenu;
